/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Visualize_Forest_Change_ContentInputs */

const en_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build your life`)
};

const ar_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابنِى حياتك`)
};

const de_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestalte dein Leben`)
};

const es_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construye tu vida`)
};

const fr_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construisez votre vie`)
};

const it_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costruisci la tua vita`)
};

const ja_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生活を整える`)
};

const ko_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인생 가꾸기`)
};

const pt_br_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construa sua vida`)
};

const ru_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стройте свою жизнь`)
};

const th_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างชีวิตของคุณ`)
};

const tr_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayatını inşa et`)
};

const zh_cn_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获得改变`)
};

const zh_tw_walkturough_visualize_forest_change_content = /** @type {(inputs: Walkturough_Visualize_Forest_Change_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獲得改變`)
};

/**
* | output |
* | --- |
* | "Build your life" |
*
* @param {Walkturough_Visualize_Forest_Change_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_visualize_forest_change_content = /** @type {((inputs?: Walkturough_Visualize_Forest_Change_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Visualize_Forest_Change_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_visualize_forest_change_content(inputs)
	if (locale === "ar") return ar_walkturough_visualize_forest_change_content(inputs)
	if (locale === "de") return de_walkturough_visualize_forest_change_content(inputs)
	if (locale === "es") return es_walkturough_visualize_forest_change_content(inputs)
	if (locale === "fr") return fr_walkturough_visualize_forest_change_content(inputs)
	if (locale === "it") return it_walkturough_visualize_forest_change_content(inputs)
	if (locale === "ja") return ja_walkturough_visualize_forest_change_content(inputs)
	if (locale === "ko") return ko_walkturough_visualize_forest_change_content(inputs)
	if (locale === "pt_br") return pt_br_walkturough_visualize_forest_change_content(inputs)
	if (locale === "ru") return ru_walkturough_visualize_forest_change_content(inputs)
	if (locale === "th") return th_walkturough_visualize_forest_change_content(inputs)
	if (locale === "tr") return tr_walkturough_visualize_forest_change_content(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_visualize_forest_change_content(inputs)
	return zh_tw_walkturough_visualize_forest_change_content(inputs)
});